import BLOG_SLUGS from '../data/blogSlugs';
import { stripLocalePrefix } from './localeRouting';

export const APP_TAB_ROUTES = {
  home: '/',
  metadata: '/metadata',
  'market-intelligence': '/market-intelligence',
  'free-credits': '/free-credits',
  'image-generator': '/image-generator',
  vectorizer: '/vectorizer',
  prompter: '/prompter',
  pricing: '/pricing',
  feedback: '/feedback',
  help: '/help',
  changelog: '/help/changelog',
  'admin-panel': '/admin'
};

const APP_VALID_PATHS = new Set(Object.values(APP_TAB_ROUTES));
const APP_PATH_TABS = Object.fromEntries(
  Object.entries(APP_TAB_ROUTES).map(([tab, path]) => [path, tab])
);
const BLOG_SLUG_SET = new Set(BLOG_SLUGS);

export const normalizeAppPath = (pathname) => {
  if (!pathname) return '';
  const localizedPath = stripLocalePrefix(pathname).pathname;
  const trimmed = localizedPath.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
};

export const getTabFromPath = (pathname) => {
  const normalized = normalizeAppPath(pathname);
  if (normalized === '/blog' || normalized.startsWith('/blog/')) return 'blog';
  if (normalized === '/admin' || normalized.startsWith('/admin/')) return 'admin-panel';
  return APP_PATH_TABS[normalized] || null;
};

export const getPathForTab = (tab) => APP_TAB_ROUTES[tab] || null;
export const isKnownAppPath = (pathname) => {
  const normalized = normalizeAppPath(pathname);
  return APP_VALID_PATHS.has(normalized) || normalized.startsWith('/admin/');
};

export const isKnownBlogPath = (pathname) => {
  const normalizedPath = normalizeAppPath(pathname);
  if (normalizedPath === '/blog') return true;
  if (normalizedPath.startsWith('/blog/')) return true;

  const trimmed = normalizedPath.replace(/^\/+|\/+$/g, '');
  if (!trimmed) return false;
  if (BLOG_SLUG_SET.has(trimmed)) return true;
  if (!trimmed.startsWith('blog/')) return false;

  return BLOG_SLUG_SET.has(trimmed.slice(5));
};
